import { render, staticRenderFns } from "./DocumentDetailV2.vue?vue&type=template&id=a08c8c74&scoped=true&"
import script from "./DocumentDetailV2.vue?vue&type=script&lang=js&"
export * from "./DocumentDetailV2.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDetailV2.vue?vue&type=style&index=0&id=a08c8c74&scoped=true&lang=css&"
import style1 from "./DocumentDetailV2.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./DocumentDetailV2.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08c8c74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VProgressCircular})
